import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const calculate3d=(id,token)=>async dispatch=>{
    dispatch({
        type:actionTypes.CALCULATE_3D_REQUEST
    })
    const options={
        url:`${api}/threeDCollections/${id}/calculateCommissions`,
        method:'POST',
        headers:{
            'Authorization':`Bearer ${token}`
        },
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.CALCULATE_3D_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.CALCULATE_3D_FAIL,
                payload:getMessage(error)
            }))
}